<template>
    <el-select v-model="val" :placeholder="$strings('word/review')" :class="[hclass]" size="small" clearable>
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
    </el-select>
</template>

<script>
import {TPL_STATUS} from "../../config/config";

export default {
    name: "filter-review",
    props: ['hclass', 'value'],
    data() {
        return {
            val: '',
            options: [
                {label: this.$strings('word/resolve'), value: TPL_STATUS.LIVING},
                {label: this.$strings('word/reject'), value: TPL_STATUS.REJECTED},
            ],
        }
    },
    created() {
        this.val = this.value;
    },
    watch: {
        value: function (v) {
            this.val = v * 1;
        },
        val: function (v) {
            this.$emit('input', v ? v : -1);
        }
    }
}
</script>

<style scoped>

</style>